import React from 'react'
/*eslint-disable*/

import { ModalBody } from 'reactstrap'
import EditDescription from './EditDescription'
import List from './List'
import AddSection from './AddSection'

import './style.css'
import CustomModal from 'views/pages/CustomModal'
const ManageChecklist = (props) => {
  let language = props.language || {}

  return (
    <CustomModal
      backPath={props.backPath}
      title={language.courses ? language.courses.manage_checklist : null}
      size='xl'
      className='question-modal'
    >
      <ModalBody
        // style={{ height: '100%', minHeight: '470px', overflow: 'hidden' }}
        style={{ height: '100%' }}
      >
        {(() => {
          switch (props.checklist.sectionActiveIndex) {
            case -1:
              return <List {...props} />
            case 'description':
              return <EditDescription {...props} />
            default:
              return (
                <AddSection
                  {...props}
                  section={
                    props.checklist.sections[props.checklist.sectionActiveIndex]
                  }
                />
              )
          }
        })()}
      </ModalBody>
    </CustomModal>
  )
}

export default ManageChecklist
